import api from 'services/api'
import {
  GET_VENDOR_SERVICE_LIST,
  CREATE_VENDOR_SERVICE,
  GET_VENDOR_SERVICE_DETAIL,
  UPDATE_VENDOR_SERVICE,
  DELETE_VENDOR_SERVICE,
  ADD_VENDOR_SERVICE_IIMAGES,
  DELETE_VENDOR_SERVICE_IMAGES,
  GET_VENDOR_LIST,
  GET_SERVICE_CATEGORIES,
  LIST_OCCUPANTS_SERVICE_DETAILS,
} from '../endpoints'

export const getVendorServiceList = async (body) => await api.post(GET_VENDOR_SERVICE_LIST, body)
export const deleteService = async (id) =>
  await api.delete(DELETE_VENDOR_SERVICE, {data: {service_id: id}})
export const getServiceDetail = async (id) =>
  await api.get(`${GET_VENDOR_SERVICE_DETAIL}?service_id=${id}`)
// export const getServiceOccupantsDetail = async (id) => await api.get(`${LIST_OCCUPANTS_SERVICE_DETAILS}?service_id=${id}`)
export const getServiceOccupantsDetail = async (body) =>
  await api.post(LIST_OCCUPANTS_SERVICE_DETAILS, body)

export const removeServiceImage = async (id) =>
  await api.delete(DELETE_VENDOR_SERVICE_IMAGES, {data: {id}})

export const getVendorList = async (id) => await api.get(`${GET_VENDOR_LIST}?service_id=${id}`)
export const getListCategories = async () => await api.post(GET_SERVICE_CATEGORIES)

export const submitService = async (values, id) =>
  await api.post(id ? UPDATE_VENDOR_SERVICE : CREATE_VENDOR_SERVICE, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
export const addServiceImages = async (id, values) =>
  await api.post(`${ADD_VENDOR_SERVICE_IIMAGES}?service_id=${id}`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
